export const apiPath = process.env.REACT_APP_API_PATH;
export const baseUrl = process.env.REACT_APP_BASE_URL;
